import { postBlock } from "../service/postBlock"
import convertAmountInCents from "../utils/amountInCents"

export const addProduct = async (
    values: any, 
    login: any
): Promise<{
    isError: boolean,
    block: any
}> => {
    const amount = convertAmountInCents(values.amount).toString()
    const { block, isError } = await postBlock("/branch/products", {
        "description": values.description,
        "amount": amount,
        "active": true,
        "groupId": values.group,
        "branchsId": login.user.branchsId,
        "nameProduct": values.name
    })
    
    return {
        isError: isError,
        block: block
    }

}